module.exports = __webpack_public_path__ + "img/logo.da7e87c7.png";